module.exports = __webpack_public_path__ + "img/loading.4a9641f6.gif";